import {
  FETCH_LOCATION_NOT_OFF_REQUEST,
  FETCH_LOCATION_NOT_OFF_SUCCESS,
  FETCH_LOCATION_NOT_OFF_FAILURE,
} from "../constants/LocationNotOffConstants";

import LocationNotOffService from "../service/LocationNotOffService";

export const fetchLocationNotOff = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_LOCATION_NOT_OFF_REQUEST });

    const data = await LocationNotOffService.getAll(date);

    dispatch({
      type: FETCH_LOCATION_NOT_OFF_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_NOT_OFF_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};


